import Select from "react-select";
import { Controller } from "react-hook-form";

export interface FieldOption {
    label: string;
    value: string | number | boolean;
}


export interface FieldConfig {
    name: string;
    label: string;
    type: "text" | "select" | "decimal" | 'number' | 'decimal2' | "checkbox" | "date";
    required?: boolean;
    options?: FieldOption[];   // only for select
    pattern?: RegExp;     // <-- NEW
    customMessage?: string;
}

export const productHeaderFields: FieldConfig[] = [
    { name: "productName", label: "Product Name", type: "text", required: true, pattern: /^[A-Za-z0-9\s\-']+$/ },
    { name: "styleNumber", label: "Style Number", type: "select", required: true, options: [] },
    { name: "materialType", label: "Material Type", type: "select", required: true, options: [] },
    { name: "category", label: "Category", type: "select", required: true, options: [] },
    { name: "subCategory", label: "SubCategory", type: "select", required: true, options: [] },
    { name: "metalColor", label: "Metal Color", type: "select", required: true, options: [] },
    { name: "complexity", label: "Complexity", type: "select", required: true, options: [] },
    { name: "collection", label: "Collection", type: "select", required: true, options: [] },
    { name: "productType", label: "Product Type", type: "select", required: true, options: [{ label: "SRP", value: 1 }, { label: "MRP", value: 2 }] },
];

export const productDetailFields: FieldConfig[] = [
    { name: "size", label: "Size", type: "decimal2", required: false },
    { name: "weight", label: "Gross Wt", type: "decimal", required: true },
    { name: "karat", label: "Karat", type: "select", required: true, options: [] },
    { name: "diamondQty", label: "Dia Quantity", type: 'decimal2', required: false },
    { name: "netWeight", label: "Net Wt", type: 'decimal', required: true },
    { name: "stoneType", label: "Stone Type", type: "text", required: false, pattern: /^[A-Za-z\s\-]+$/ },
    { name: "makingType", label: "Making Type", type: "text", required: true, pattern: /^[A-Za-z\s\-]+$/ },
    { name: "tag", label: "Tag", type: "text", required: false, pattern: /^[A-Za-z0-9\s\-]+$/ },
    { name: "collorStoneWeight", label: "Color Stone Wt", type: 'decimal', required: false },

];

export const costComponent: FieldConfig[] = [
    { name: "goldCost", label: "Gold Cost", type: 'decimal2' },
    { name: "diamondCost", label: "Diamond Cost", type: 'decimal2' },
]

export const rawMaterial = [
    { name: "mf", label: "MF", type: "text", required: false, pattern: /^[A-Za-z0-9\-]+$/ },
    { name: "rowType", label: "Raw Type", type: "select", required: false, options: [] },
    { name: "rawkarat", label: "Karat", type: "select", required: true, options: [] },
    { name: "weight", label: "Gross Weight", type: "decimal", required: false },
    { name: "qty", label: "Quantity", type: 'decimal2', required: false },
    { name: "stoneWeight", label: "Stone Weight", type: "decimal", required: false },
    { name: "diamondWt", label: "Dia Weight", type: "decimal", required: false },
    { name: "diamondSize", label: "Dia Size", type: "decimal2", required: false },
]


export const RenderInput = ({ field, register, errors, control, isDisabled = false, placeholder, rules }: any) => {
    return (
        <div className="col-md-3 mb-1">
            <label className="form-label">
                {field?.label} {field?.required && <span className="text-danger">*</span>}
            </label>

            {field?.type === "select" && (
                <Controller
                    name={field?.name}
                    control={control}
                    rules={{
                        validate: (v) => {
                            if (isDisabled) return true;
                            if (field?.required && !v) return `${field?.label} is required`;
                            return true;
                        }
                    }}
                    render={({ field: controllerField }) => {
                        const options = field?.options || [];

                        return (
                            <Select
                                {...controllerField}
                                options={options}
                                placeholder={`--Select ${field?.label}--`}
                                value={options?.find((opt: { value: any; }) => opt?.value === controllerField?.value) || null}
                                onChange={(val: any) => controllerField?.onChange(val?.value || "")}
                                isClearable
                                isDisabled={isDisabled}
                                className="react-select-container"
                                classNamePrefix="react-select"
                                styles={{
                                    control: (provided: any, state: any) => ({
                                        ...provided,
                                        minHeight: "27px",
                                        height: "27px",
                                        fontSize: "12px",
                                        borderWidth: "1px",
                                        borderRadius: "0.25rem",
                                        padding: "0 2px",
                                        borderColor: errors[field?.name]
                                            ? "#ff6c6c"
                                            : state.isFocused ? "#86b7fe" : "#ced4da",
                                        "&:hover": {
                                            borderColor: "#86b7fe",
                                        },
                                    }),
                                    indicatorsContainer: (base: any) => ({
                                        ...base,
                                        height: "28px"
                                    }),
                                    dropdownIndicator: (base: any) => ({
                                        ...base,
                                        padding: "4px",
                                        color: "#6c757d",
                                        ":hover": { color: "#495057" }
                                    }),
                                    valueContainer: (base: any) => ({
                                        ...base,
                                        padding: "0 8px",
                                    }),
                                    input: (base: any) => ({
                                        ...base,
                                        margin: 0,
                                        padding: 0,
                                    }),
                                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                                }}
                                menuPosition="fixed"
                            />
                        );
                    }}
                />
            )}
            {field?.type === "decimal" && (
                <input
                    type="number"
                    step="0.001"
                    className={`form-control form-control-sm ${errors[field?.name] ? "is-invalid" : ""
                        }`}
                    {...register(field?.name, {
                        required: field?.required ? `${field?.label} is required` : false,
                        pattern: {
                            value: /^\d+(\.\d{1,3})?$/,
                            message: `Enter a valid ${field?.label?.toLowerCase()}`
                        }
                    })}
                    onWheel={(e) => e.currentTarget.blur()}
                    onKeyDown={(e) => {
                        const allowedKeys = [
                            "Backspace", "Tab", "ArrowLeft", "ArrowRight",
                            "Delete", "Home", "End"
                        ];

                        if ((e.ctrlKey || e.metaKey) && ["a", "c", "v", "x", "z", "y"].includes(e.key.toLowerCase())) {
                            return;
                        }

                        if (allowedKeys.includes(e.key)) return;

                        if (/^\d$/.test(e.key)) return;

                        if (e.key === "." && !e.currentTarget.value.includes(".")) return;

                        e.preventDefault();
                    }}

                    placeholder={`${placeholder?.charAt(0)?.toUpperCase() + placeholder?.slice(1)?.toLowerCase() || ''}`}

                    onInput={(e: React.FormEvent<HTMLInputElement>) => {
                        let value = e.currentTarget.value;

                        const digits = value.replace(/\D/g, "");

                        if (digits.length > 10) {
                            value = value.slice(0, -1);
                            e.currentTarget.value = value;
                            return;
                        }
                        if (value.includes(".")) {
                            const [int, dec] = value.split(".");
                            if (dec?.length > 3) {
                                e.currentTarget.value = int + "." + dec.slice(0, 3);
                            }
                        }
                    }}
                    disabled={isDisabled}
                />

            )}
            {field?.type === "number" && (
                <input
                    type="number"
                    className={`form-control form-control-sm ${errors[field?.name] ? "is-invalid" : ""
                        }`}
                    {...register(field?.name, {
                        required: field?.required ? `${field?.label} is required` : false,
                        pattern: {
                            value: /^[0-9]+$/,
                            message: "Enter a valid whole number",
                        },
                        ...rules
                    })}
                    placeholder={`${placeholder?.charAt(0)?.toUpperCase() + placeholder?.slice(1)?.toLowerCase() || ''}`}
                    onWheel={(e) => e.currentTarget.blur()}
                    onKeyDown={(e) => {
                        const allowedKeys = [
                            "Backspace",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                            "Delete",
                            "Home",
                            "End",
                        ];

                        if ((e.ctrlKey || e.metaKey) &&
                            ["a", "c", "v", "x", "z", "y"].includes(e.key.toLowerCase())
                        ) {
                            return;
                        }

                        if (allowedKeys.includes(e.key)) return;

                        if (/^\d$/.test(e.key)) return;

                        e.preventDefault();
                    }}

                    onInput={(e: React.FormEvent<HTMLInputElement>) => {
                        let value = e.currentTarget.value;

                        value = value.replace(/\D/g, "");

                        if (value.length > 10) {
                            value = value.slice(0, 10);
                        }

                        e.currentTarget.value = value;
                    }}
                    disabled={isDisabled}
                />
            )}
            {field?.type === "decimal2" && (
                <input
                    type="text"
                    inputMode="decimal"
                    placeholder={`${placeholder?.charAt(0)?.toUpperCase() + placeholder?.slice(1)?.toLowerCase() || ''}`}
                    className={`form-control form-control-sm ${errors[field?.name] ? "is-invalid" : ""}`}
                    {...register(field?.name, {
                        required: field?.required ? `${field?.label} is required` : false,
                        pattern: {
                            value: /^\d{1,10}(\.\d{0,2})?$/,
                            message: `Enter valid ${field?.label?.toLowerCase()} (max 10 digits & 2 decimals)`
                        }
                    })}
                    onKeyDown={(e) => {
                        const allowedNav = [
                            "Backspace", "Tab", "ArrowLeft", "ArrowRight",
                            "Delete", "Home", "End"
                        ];

                        if (allowedNav.includes(e.key)) return;

                        if (e.ctrlKey || e.metaKey) return;

                        // Allow digits
                        if (/^\d$/.test(e.key)) return;

                        // Allow ONE dot only
                        if (e.key === "." && !e.currentTarget.value.includes(".")) return;

                        e.preventDefault();
                    }}
                    onInput={(e) => {
                        const input = e.currentTarget;
                        let val = input.value;
                        if (val === "." || val === "") return;
                        val = val.replace(/[^0-9.]/g, "");
                        const parts = val.split(".");
                        if (parts.length > 2) {
                            val = parts[0] + "." + parts[1];
                        }

                        const [intPart, decPart] = val.split(".");

                        if (intPart && intPart.length > 10)
                            val = intPart.slice(0, 10) + (decPart ? "." + decPart : "");

                        if (decPart && decPart.length > 2)
                            val = intPart + "." + decPart.slice(0, 2);

                        input.value = val;
                    }}
                    disabled={isDisabled}
                />
            )}

            {field?.type === "text" && (
                <input
                    type="text"
                    className={`form-control form-control-sm ${errors[field?.name] ? "is-invalid" : ""}`}
                    placeholder={`${placeholder?.charAt(0)?.toUpperCase() + placeholder?.slice(1)?.toLowerCase() || ''}`}
                    {...register(field?.name, {
                        validate: (value: string) => {
                            const trimmed = value?.trim() ?? '';
                            if (isDisabled) return true;

                            if (/^\s/.test(value)) {
                                return `${field?.label} cannot start with a space`;
                            }

                            if (field?.required && trimmed === "") {
                                return `${field?.label} is required`;
                            }

                            if (!field?.required && value?.trim() !== "" && trimmed === "") {
                                return "Spaces only are not allowed";
                            }

                            if (trimmed && field?.pattern && !field?.pattern?.test(trimmed)) {
                                return field?.customMessage || "Invalid format";
                            }
                            return true;
                        }
                    })}
                    disabled={isDisabled}
                />
            )}

            {field?.type === "date" && (
                <input
                    type="date"
                    min={new Date().toISOString().split("T")[0]}
                    className={`form-control form-control-sm ${errors[field?.name] ? "is-invalid" : ""}`}
                    {...register(field?.name, {
                        required: field?.required ? `${field?.label} is required` : false,
                        validate: (value: string) => {
                            if (isDisabled) return true;

                            if (!value && field?.required) {
                                return `${field?.label} is required`;
                            }

                            if (value) {
                                const selectedDate = new Date(value);
                                const today = new Date();

                                today.setHours(0, 0, 0, 0);
                                selectedDate.setHours(0, 0, 0, 0);

                                if (selectedDate < today) {
                                    return `${field?.label} cannot be a past date`;
                                }
                            }

                            return true;
                        },
                    })}
                    disabled={isDisabled}
                />
            )}

            {errors[field?.name] && (
                <small className="text-danger">{errors[field?.name]?.message}</small>
            )}
        </div>
    );
};
